import React from "react";
import serviceUnavailable from "../assets/error-screens/service_unavailable.svg";
import { useTranslation } from "react-i18next";
import "./no_data_found.css";

const ServiceUnavailable = () => {
    const { t, i18n } = useTranslation();
    return (
        <div className="no-data-found-container d-flex justify-content-center">
            <div className="no-data-found-content">
                <div className="w-100"><img src={serviceUnavailable} alt="service unavailable" className="mx-auto d-block" /></div>
                <div className="no-data-found-main-heading">{t('auditRequest.service_unavailable_label')}</div>
                <div className="no-data-found-sub-heading">{t('auditRequest.service_unavailable_sub_label')}</div>
            </div>
        </div>
    );
};
export default ServiceUnavailable;